import { cx } from 'utils';

/**
 * LogoBadge — the LearnXCode logo image shown as a self-contained dark rounded
 * tile ("app-icon" style). Used in the title area (navbar) and the auth pages.
 *
 * The source artwork (`public/brand/learnx-logo.png`) carries its own dark
 * background and baked-in wordmark, so the badge reads as intentional on both
 * light (white navbar) and dark surfaces without recolouring. The rounded tile
 * clips the square artwork's corners; a hairline ring keeps it crisp on white.
 *
 * Keep the asset in sync with the copy the emails link to — the same file is
 * served at `/brand/learnx-logo.png` and referenced by `functions/src/templates.js`.
 */
const LOGO_SRC = '/brand/learnx-logo.png';

const SIZES = { sm: 32, md: 40, lg: 52 };

export default function LogoBadge({ size = 'md', className = '', ...props }) {
  const px = SIZES[size] || SIZES.md;
  return (
    <span
      className={cx(
        'inline-flex shrink-0 select-none items-center justify-center overflow-hidden rounded-xl bg-black ring-1 ring-black/10 dark:ring-white/10',
        className
      )}
      style={{ width: px, height: px }}
      {...props}
    >
      <img
        src={LOGO_SRC}
        alt="LearnXCode"
        width={px}
        height={px}
        className="h-full w-full object-cover"
        draggable={false}
      />
    </span>
  );
}
